const getCookie = (name) => {
  if (typeof document === "undefined") {
    return null;
  }

  const prefix = `${encodeURIComponent(name)}=`;
  const cookie = document.cookie
    .split(";")
    .map((entry) => entry.trim())
    .find((entry) => entry.startsWith(prefix));

  if (!cookie) {
    return null;
  }

  return decodeURIComponent(cookie.slice(prefix.length));
};

export const getCsrfToken = () => {
  const cookieNameHash = import.meta.env.VITE_COOKIE_NAME_HASH;
  if (!cookieNameHash) {
    throw new Error("VITE_COOKIE_NAME_HASH_MISSING");
  }
  return getCookie(`csrf-${cookieNameHash}`);
};
